import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getCustomizeData(type) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/customize/${type}`;
    return httpGet(apiUrl);
  }
  addDefaultReminder(type) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/customize/${type}`;
    return httpPut(apiUrl);
  }

  addCustomizeData(type, dataType, data) {
    data.dataType = dataType;
    data.handle = "add";
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/customize/${type}`;
    return httpPut(apiUrl, data);
  }

  updateCustomizeData(type, dataType, data) {
    data.dataType = dataType;
    data.handle = "update";
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/customize/${type}`;
    return httpPut(apiUrl, data);
  }

  removeCustomizeData(type, dataType, data) {
    data.dataType = dataType;
    data.handle = "remove";
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/customize/${type}`;
    return httpPut(apiUrl, data);
  }
}
